const weaterbysTabs = ['weatherbys-overview', 'sire-reference'];

const calculateActiveClass = (isSire, hasWeatherbys, isSubTabSelected, tab) => {
    if (!isSire || !isSubTabSelected) { return 'ui-tabs__tab_selected'; }

    return `ui-tabs__tab_selected ${
        (hasWeatherbys && (!tab || weaterbysTabs.includes(tab))) ?
        'weatherbys' : 'dark'
        }`;
};

export default calculateActiveClass;



// WEBPACK FOOTER //
// ./src/js/shared/nav/helpers/calculateActiveClass.js